import { render, staticRenderFns } from "./LeftContent.vue?vue&type=template&id=4e9fca5b&scoped=true"
import script from "./LeftContent.vue?vue&type=script&lang=js"
export * from "./LeftContent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e9fca5b",
  null
  
)

export default component.exports